import React from 'react';
import { Box, Typography } from '@mui/material';

const DataUploadPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Upload Data
      </Typography>
      <Typography variant="body1">
        Data upload functionality coming soon...
      </Typography>
    </Box>
  );
};

export default DataUploadPage;
